import { useMemo, useEffect } from 'react';
import { createPortal } from 'react-dom';

const Portal = ({ children, dataMetrics, dataTestId, }) => {
    // support server side rendering
    /* istanbul ignore next */
    if (typeof document === "undefined")
        return null;
    const portalEl = useMemo(() => document.createElement("div"), []);
    portalEl.setAttribute("data-testid", dataTestId || "portal");
    dataMetrics && portalEl.setAttribute("data-metrics", dataMetrics);
    useEffect(() => {
        document.body.appendChild(portalEl);
        return () => {
            document.body.removeChild(portalEl);
        };
    }, []);
    return createPortal(children, portalEl);
};

export { Portal };
//# sourceMappingURL=Portal.esm.js.map
